import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appKonamiCode]'
})
export class KonamiCodeDirective {

  @Output()
  private konami: EventEmitter<void>;

  private sequence: string[];

  private konamiCode: string[];

  constructor() {
    this.konami = new EventEmitter<void>();
    this.sequence = [];
    this.konamiCode = ['38', '38', '40', '40', '37', '39', '37', '39', '66', '65'];
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.keyCode) {
      this.sequence.push(event.keyCode.toString());

      if (this.sequence.length > this.konamiCode.length) {
        this.sequence.shift();
      }

      if (this.isKonamiCode()) {
        this.konami.emit();
      }
    }
  }

  isKonamiCode(): boolean {
    return this.konamiCode.every((code: string, index: number) => code === this.sequence[index]);
  }

  /*
  Ways to use:

  export class AppComponent  {
    public isKonamiEntered:boolean = false;
    public show(event:boolean): void {
      this.isKonamiEntered = true;
      if (event) {
        window.location.href = 'http://www.8bbit.com/play/contra/1125';
      }
    }
  }

  <div appKonamiCode (konami)='show($event)'>
    <div *ngIf="isKonamiEntered">
      You entered the konami code!
    </div>
  </div>


  */
}
